// extracted by mini-css-extract-plugin
module.exports = {"gameOverText":"style_gameOverText__3XGwr","bolder":"style_bolder__gNfwZ","textContainer":"style_textContainer__1Of3v"};